jQuery(document).ready(function() {
	var jQ = jQuery;
	var selectors = {
		TOTAL_ITEMS: '.cart-total-items .items-count',
		TOTAL_PRICE: '',
		SUBMIT_ADD_TO_CART: 'input[type=image], input.submit-add-to-cart',
		FORM_ADD_TO_CART: 'form[action*="/cart/add"]',
		FORM_UPDATE_CART: 'form[name=cartform]',
		FORM_UPDATE_CART_BUTTON: 'form[name=cartform] input[name=update]',
		FORM_UPDATE_CART_BUTTONS: 'input[type=image], input.button-update-cart',
		LINE_ITEM_ROW: '.cart-line-item',
		LINE_ITEM_QUANTITY_PREFIX: 'input#updates_',
		LINE_ITEM_PRICE_PREFIX: '.cart-line-item-price-',
		LINE_ITEM_REMOVE: '.remove a',
		EMPTY_CART_MESSAGE: '#empty'
	};
	var text = {
		ITEM: 'Item',
		ITEMS: 'Items'
	};
	var formatMoney = function(price) {
			return Shopify.formatMoney(price, '${{ amount }}');

		};
	$('#testhook').on('click', function() {
		console.log('test hook');
	});
	function add_to_cart_supermarche_and_ajax(target) {
		var minLength = 1; // Minimum length
		var quantityId = $(target).find(".quantity");
		if(quantityId.val() < minLength){
		console.log("nope");
		quantityId.val(1);
		alert("Quantity must be greater than or equal to 1");
		}
		else {
		console.log('e.target: ', target);
		jQ(target).find(selectors.SUBMIT_ADD_TO_CART).attr('disabled', true).addClass('disabled');
		Shopify.addItemFromForm(target);
		var submitButton = $(target).find(".submit-add-to-cart");
		console.log('submitButton: ', submitButton);
		addToCart(submitButton);
		}
	}
	jQ(selectors.FORM_ADD_TO_CART).submit(function(e) {
		e.preventDefault();
		add_to_cart_supermarche_and_ajax(e.target);
	});
	jQ(selectors.FORM_UPDATE_CART_BUTTON).click(function(e) {
		e.preventDefault();
		jQ(e.target.form).find(selectors.FORM_UPDATE_CART_BUTTONS).attr('disabled', true).addClass('disabled');
		Shopify.updateCartFromForm(e.target.form);
	});
	jQ(selectors.FORM_UPDATE_CART).delegate(selectors.LINE_ITEM_REMOVE, 'click', function(e) {
		e.preventDefault();
		var vid = this.href.split('/').pop().split('?').shift();
		Shopify.removeItem(vid);
		jQ(this).parents(selectors.LINE_ITEM_ROW).remove();
	});
	Shopify.onItemAdded = function(line_item, form) {
		jQ(form).find(selectors.SUBMIT_ADD_TO_CART).attr('disabled', false).removeClass('disabled');
		Shopify.getCart();
		setTimeout(function() {
			$('.nav-cart').addClass('pulsate')
		}, 2200);
		setTimeout(function() {
			$('.nav-cart').removeClass('pulsate');
		}, 2500);
	};
	$("#wishl-wrapper").on("submit", "form[action*='/cart/add']", function(e) {
		e.preventDefault();
		console.log('button clicked from favorites page');
		var target = $(e.target).closest('form');
		console.log('target: ', target);
		add_to_cart_supermarche_and_ajax(target);
	});
	function addToCart(submitButton) {
		submitButton.find("i.fa-check").css('display', 'inline-block');
		submitButton.find("i.fa-plus").css('display', 'none');
		submitButton.css('border-color', '#8B0204');
		submitButton.parent().parent().find(".in-cart-overlay").css('display', 'block');
		submitButton.parent().parent().find(".in-cart-overlay i").css('display', 'block');
		console.log("submitButton: ", submitButton);
		var prodname = submitButton.closest("#add-to-cart-animation-wrapper").find('#prod-name').text();
		console.log('prodname: ', prodname);
		var proddesc = submitButton.closest("#add-to-cart-animation-wrapper").find('#prod-desc').text();
		console.log('proddesc: ', proddesc);
		var prodquantity = submitButton.closest("#add-to-cart-animation-wrapper").find('.quantity').val();
		console.log('prodquantity: ', prodquantity);
		var prodvar;
		if (submitButton.closest("#add-to-cart-animation-wrapper").find(".product-select option:selected").text().indexOf('Default') >= 0) prodvar = '';
		else prodvar = submitButton.closest("#add-to-cart-animation-wrapper").find(".product-select option:selected").text();
		if (!prodvar) {
			prodvar = submitButton.closest("#add-to-cart-animation-wrapper").find('.variant-title').text();
			prodvar = prodvar.replace('- ', '');
		}
		console.log('prodvar: ', prodvar);
		if ($("#favourites").length > 0) {
			$("#modal-cart-alert .prod-caption").html('<span class="prodquantity">' + prodquantity + 'X</span>' + ' ' + prodname + '<br/>' + '<span class="proddesc"> ' + proddesc + '</span>');
			console.log('favourites page')
		}
		else {$("#modal-cart-alert .prod-caption").html('<span class="prodquantity">' + prodquantity + 'X</span>' + ' ' + prodname + '<br/>' + '<span class="proddesc">' + prodvar + ' ' + proddesc + '</span>');}
		$('#cartalert').click();
		setTimeout(function() {
			$(".submit-add-to-cart").css('border-color', '#8bb43f')
		}, 1000);
		setTimeout(function() {
			$('#modal-cart-alert').addClass('bounceInstart slideInDown alertflex')
		}, 0);
		setTimeout(function() {
			$('#modal-cart-alert').removeClass('hidden')
		}, 0);
		setTimeout(function() {
			$('#modal-cart-alert').addClass('slideOutUp')
		}, 2000);
		setTimeout(function() {
			$('#modal-cart-alert').removeClass('slideOutUp bounceInstart slideInDown alertflex')
		}, 2200);
		setTimeout(function() {
			$('#modal-cart-alert').addClass('hidden')
		}, 2200);
		submitButton.closest("#add-to-cart-animation-wrapper").find('.quantity').val(1);
		submitButton.closest("#add-to-cart-animation-wrapper").find('.minus-btn').addClass('invisible');
	}
	Shopify.onCartUpdate = function(cart, form) {
		var message = '<span class="cart-total-items">' + cart.item_count + ' </span>';
		jQ(selectors.TOTAL_ITEMS).html(message);
		var price = formatMoney(cart.total_price);
		jQ(selectors.TOTAL_PRICE).html(price);
		if ((jQ(selectors.EMPTY_CART_MESSAGE).length > 0) && cart.item_count == 0) {
			jQ(selectors.FORM_UPDATE_CART).hide();
			jQ(selectors.EMPTY_CART_MESSAGE).show();
		}
		form = form || false;
		if (form) {
			if (cart.item_count > 0) {
				jQ.each(cart.items, function(index, cartItem) {
					jQ(selectors.LINE_ITEM_PRICE_PREFIX + cartItem.id).html(formatMoney(cartItem.line_price));
					jQ(selectors.LINE_ITEM_QUANTITY_PREFIX + cartItem.id).val(cartItem.quantity);
				});
				jQ(form).find('input[value=0]').parents(selectors.LINE_ITEM_ROW).remove();
				jQ(form).find(selectors.FORM_UPDATE_CART_BUTTONS).attr('disabled', false).removeClass('disabled');
			}
		}
	};
	Shopify.onError = function(XMLHttpRequest, textStatus) {};
});